export default __webpack_public_path__ + "static/media/frente.b8a28b01.png";